import React, { useEffect, useState } from 'react';
import { instance } from '../../api/axiosInstance';
import ManagerSidebar from '../../components/ManagerSidebar';
import NoticeComponent from '../../components/NoticeComponent';
import ArticleModal from './ArticleModal'; // 기사 수정을 위한 모달 컴포넌트
import { FaUpload } from 'react-icons/fa';
import axios from "axios";

interface Article {
    id: number;
    title: string;
    content: string;
    imgURL?: string;
    url?: string;
}

const ArticleForm: React.FC = () => {
    const [formData, setFormData] = useState({
        title: '',
        content: '',
        url: ''
    });

    const [imageFile, setImageFile] = useState<File | null>(null);
    const [articles, setArticles] = useState<Article[]>([]);
    const [selectedArticle, setSelectedArticle] = useState<Article | null>(null);

    useEffect(() => {
        fetchArticles();
    }, []);


    const fetchArticles = async () => {
        try {
            const response = await instance.get<Article[]>('/api/articles');
            setArticles(response.data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                // Axios-specific error handling
                console.error('Axios error:', error.response?.data || error.message);

            } else {
                // Generic error handling
                console.error('Unexpected error:', error);

            }
        }
    };

    const handleChange = (
        event: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setImageFile(event.target.files[0]);
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        if (!formData.title || !formData.content || !imageFile) {
            alert('Title, Content, and Image are required.');
            return;
        }

        const data = new FormData();
        data.append('title', formData.title);
        data.append('content', formData.content);
        data.append('url', formData.url);
        data.append('file', imageFile);

        try {
            await instance.post('/api/articles', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert('Article created successfully!');
            resetForm();
            fetchArticles();
        } catch (error) {
            console.error(error);
            alert('Failed to create article.');
        }
    };

    const resetForm = () => {
        setFormData({
            title: '',
            content: '',
            url: ''
        });
        setImageFile(null);
    };

    const handleEdit = (article: Article) => {
        setSelectedArticle(article);
    };

    const handleDelete = async (id: number) => {
        await instance.delete(`/api/articles/${id}`);
        fetchArticles();
    };

    return (
        <section className="max-w-[2560px] w-full mx-auto h-screen flex mt-[90px]">
            <ManagerSidebar />
            <div className="max-w-[1440px] w-full mx-auto py-8 flex flex-col flex-1 overflow-auto overflow-x-hidden ">
                <NoticeComponent title="기사 관리" content="" />

                <div className="max-w-[700px] bg-white mb-8">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="mb-4">
                            <label className="block mb-1">제목</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                className="w-full h-[45px] px-3 py-2 border rounded-md focus:outline-none "
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-1">내용</label>
                            <textarea
                                name="content"
                                value={formData.content}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded-md focus:outline-none "
                                required
                            ></textarea>
                        </div>
                        <div className="mb-4">
                            <label className="block mb-1">이미지</label>
                            <input
                                type="file"
                                name="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange}
                                className="w-full text-sm text-gray-500 !cursor-pointer file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-MainTextColor file:text-white hover:file:bg-MainColor !transition !duration-300 !ease-in-out"
                                required
                            />
                            {imageFile && (
                                <img
                                    src={URL.createObjectURL(imageFile)}
                                    alt="Preview"
                                    className="mt-2 w-32 h-32 object-cover border rounded-md"
                                />
                            )}
                        </div>
                        <div className="mb-4">
                            <label className="block mb-1">URL</label>
                            <input
                                type="text"
                                name="url"
                                value={formData.url}
                                onChange={handleChange}
                                className="w-full h-[45px] px-3 py-2 border rounded-md focus:outline-none "
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full mt-8 bg-black text-white font-bold text-sm py-4 rounded-lg hover:bg-opacity-70 transition duration-300"
                        >
                            <div className="flex items-center justify-center gap-3">
                                <FaUpload />
                                기사 등록하기
                            </div>
                        </button>
                    </form>
                </div>

                <div>
                    {articles.length === 0 ? (
                        <p className="text-gray-500">등록된 기사가 없습니다.</p>
                    ) : (
                        articles.map((article) => (
                            <div key={article.id} className="mb-4 p-4 border rounded-md">
                                <h3 className="text-lg font-bold">{article.title}</h3>
                                <button onClick={() => handleEdit(article)} className="mr-2 text-blue-500">Edit</button>
                                <button onClick={() => handleDelete(article.id)} className="text-red-500">Delete</button>
                            </div>
                        ))
                    )}
                    {selectedArticle && (
                        <ArticleModal
                            article={selectedArticle}
                            onClose={() => setSelectedArticle(null)}
                            onArticleUpdated={fetchArticles}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};

export default ArticleForm;
